



















import {Component, Vue} from "vue-property-decorator";
import OrderView from "@/components/Dashboard/Orders/OrderView.vue";
import OrderService from "@/service/OrderService";
import Order from "@/api/Order";

@Component({
  components: {OrderView}
})
export default class OrderSingle extends Vue {
  public title = "سفارش";
  private orderId = 0;
  private order: Order | null = null;

  mounted() {
    window.scrollTo(0, 0);
    this.orderId = parseInt(this.$route.params.orderId.toString());
    this.getOrder();
  }

  public async getOrder() {
    this.$store.dispatch('loading/showLoadingModal');
    this.order = await OrderService.getOrderById(this.orderId);
    this.$store.dispatch('loading/hideLoadingModal');
    this.setTitle();
  }

  private setTitle() {
    document.title = 'سفارش شماره ' + this.order?.incrementId;
  }

  goBack(){
    console.log("go back");
  }
}
